module.exports = __webpack_public_path__ + "img/image02_sp.1cba7f0b.jpg";